import { motion } from 'framer-motion';

function Contact() {
  return (
    <>
      <section id="contact" style={{ 
        padding: '3rem 1rem', 
        backgroundColor: '#1F1F1F', 
        marginLeft:-8,
        marginRight:-8,
        color: '#FFFFFF',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated background elements - adjusted for mobile */}
        <motion.div 
          initial={{ x: -100, y: -100, opacity: 0.1 }}
          animate={{ x: 0, y: 0, opacity: 0.2 }}
          transition={{ duration: 10, repeat: Infinity, repeatType: 'reverse' }}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '200px',
            height: '200px',
            background: 'radial-gradient(circle, #FFC300, transparent 70%)',
            borderRadius: '50%',
            filter: 'blur(30px)',
            zIndex: 0
          }}
        />
        
        <motion.div 
          initial={{ x: 100, y: 100, opacity: 0.1 }}
          animate={{ x: 0, y: 0, opacity: 0.2 }}
          transition={{ duration: 8, repeat: Infinity, repeatType: 'reverse' }}
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '250px',
            height: '250px',
            background: 'radial-gradient(circle, #0088CC, transparent 70%)',
            borderRadius: '50%',
            filter: 'blur(30px)',
            zIndex: 0
          }}
        />
        
        <div style={{ 
          maxWidth: '64rem', 
          margin: '0 auto', 
          padding: '0 1rem',
          position: 'relative',
          zIndex: 1
        }}>
          <motion.h2 
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            style={{ 
              fontSize: 'clamp(1.5rem, 5vw, 2.25rem)', 
              fontWeight: '700', 
              marginBottom: '1rem', 
              fontFamily: 'Poppins, sans-serif',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}
          >
            Join Our Community
          </motion.h2>
          
          <motion.p 
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            style={{ 
              fontSize: 'clamp(1rem, 3vw, 1.25rem)', 
              marginBottom: '1.5rem', 
              fontFamily: 'Poppins, sans-serif',
              lineHeight: '1.6',
              padding: '0 0.5rem'
            }}
          >
            Connect with like-minded investors, get exclusive insights, and stay updated on our latest opportunities.
          </motion.p>
          
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            style={{
              margin: '1.5rem 0',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <motion.a
               href="https://t.me/AICUAE"
               target="_blank"
               rel="noopener noreferrer"
               className="join-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{
                backgroundColor: '#0088CC',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '50px',
                textDecoration: 'none',
                fontSize: 'clamp(1rem, 3vw, 1.125rem)',
                fontWeight: '600',
                fontFamily: 'Poppins, sans-serif',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                whiteSpace: 'nowrap'
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69.03-.1.06-.2-.06-.3s-.35-.04-.5-.04c-.21 0-.57.1-1.78.53-1.33.48-2.48.61-2.79.61-.58 0-1.4-.28-1.4-1.04 0-.42.25-.88.88-1.09 3.92-1.5 5.82-2.42 6.89-2.83 3.2-1.2 3.85-1.42 4.28-1.45.9-.05 1.43.27 1.45.85.03.6-.68.92-1.42 1.25z"/>
              </svg>
              Join Us Now
            </motion.a>
          </motion.div>
          
          <motion.p 
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            style={{ 
              fontSize: 'clamp(0.875rem, 3vw, 1rem)', 
              fontFamily: 'Poppins, sans-serif',
              opacity: '0.8',
              marginTop: '1.5rem'
            }}
          >
            Be part of our growing network of African investors
          </motion.p>
        </div>
      </section>

      {/* Footer */}
      <motion.footer
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        style={{
          backgroundColor: '#1F1F1F',
          marginLeft:-8,
          marginRight:-8,
          marginBottom:-10,
          color: 'rgba(255, 255, 255, 0.7)',
          padding: '1.5rem 1rem',
          textAlign: 'center',
          fontSize: '0.75rem',
          fontFamily: 'Poppins, sans-serif'
        }}
      >
        <div style={{ maxWidth: '64rem', margin: '0 auto', padding: '0 0.5rem' }}>
          <p style={{ marginBottom: '1rem', lineHeight: '1.6' }}>
            The African Investment Club is a private investment Club. Past performance does not guarantee future results. 
            Please consult with legal and financial advisors before investing.
          </p>
          
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '1rem',
            marginBottom: '1rem',
            flexWrap: 'wrap'
          }}>
            <motion.a 
              href="/privacy-policy" 
              style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'none', fontSize: '0.75rem' }}
              whileHover={{ color: '#FFFFFF', scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              Privacy Policy
            </motion.a>
            <motion.a 
              href="/terms-of-use" 
              style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'none', fontSize: '0.75rem' }}
              whileHover={{ color: '#FFFFFF', scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              Terms of Use
            </motion.a>
          </div>
          
          <p style={{ fontSize: '0.75rem' }}>
            © {new Date().getFullYear()} AIC. All rights reserved.
          </p>
        </div>
      </motion.footer>
    </>
  );
}
 
export default Contact;